export default __webpack_public_path__ + "static/media/icon_login_close.22873f15.svg";